export default{"initial.canvas.canvas":function(){return{"rect.appearing":()=>[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:'initial'}],"*":null}},"update.canvas.canvas":{"rect.updating":[{slot:'middle'}]}};


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-charts/src/_internal/components/canvases/canvas.animation.js
// module id = null
// module chunks = 